import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import { RelationsRedux } from '../Redux/RelationsRedux'

const relationsCrudObservable = createCRUDObservable({
  mainRedux: RelationsRedux,
  reduxPath: 'relations',
})

export const relationsObservers = Object.assign({}, relationsCrudObservable.observers, {})

export const relationsEpic = combineEpics(
  relationsCrudObservable.epic,
)



// WEBPACK FOOTER //
// ./src/Data/Observables/RelationsObservable.js